import { boardEntityTypes } from '../../BoardsListHeader/constants/boardEntityTypes';

export const summaryCards = {
  [boardEntityTypes.COUNCIL]: {
    preparationCard: {
      title: 'CouncilStatus_InPreparations',
      description: 'CouncilStatus_InPreparationDescription',
    },
    activeCard: {
      title: 'CouncilStatus_OnGoings',
      description: 'CouncilStatus_OnGoingDescription',
    },
    signPendingCard: {
      title: 'CouncilStatus_SignaturePendings',
      description: 'CouncilStatus_SignaturePendingDescription',
    },
    closedCard: {
      title: 'CouncilStatus_Completeds',
      description: 'CouncilStatus_CompletedDescription',
    },
  },
  [boardEntityTypes.BASIC_BOARD]: {
    preparationCard: {
      title: 'BoardStatus_InPreparations',
      description: 'BoardStatus_InPreparationDescription',
    },
    activeCard: {
      title: 'BoardStatus_OnGoings',
      description: 'BoardStatus_OnGoingDescription',
    },
    signPendingCard: {
      title: '',
      description: '',
    },
    closedCard: {
      title: 'BoardStatus_Completeds',
      description: 'BoardStatus_CompletedDescription',
    },
  },
};
